// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconExpandArrows.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconExpandArrows = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 12 12" fill="currentColor" { ...props }>
    <path d="M6 12L1.5 8.57143L10.5 8.57143L6 12Z" />
    <path d="M6 0L10.5 3.42857H1.5L6 0Z" />
  </BaseIcon>
);

export default IconExpandArrows;
